module.exports = __webpack_public_path__ + "media/images/futurize-logo-be8c22e2b82cbe7314821443cc60235a.png";